import { _Types, getServerData } from "@reactivated";

import {
    getDocument,
    getJSONScriptData,
    getWindow,
} from "@thelabnyc/thelabui/src/utils/dom";

export const IS_PUPPETEER = (() => {
    const _window = getWindow();
    return !!(
        _window && _window.navigator.userAgent.includes("HeadlessChrome")
    );
})();

export const IS_VITEST = typeof process !== "undefined" && !!process.env.VITEST;

export type ReactivatedContext = Readonly<_Types["Context"]>;

let _context: ReactivatedContext | null = null;

/**
 * Stash the reactivated context for non-component code (models, utils).
 *
 * During SSR there is no window/document, so getReactivatedContext() has
 * nothing to read and code like the product-model static-URL fallback
 * diverges from the client render (a hydration text mismatch in e.g. the
 * product-card JSON-LD). The site renderer.tsx receives the request context
 * and must call this before rendering.
 */
export const setReactivatedContext = (context: ReactivatedContext): void => {
    _context = context;
};

export const getReactivatedContext = (): ReactivatedContext | null => {
    if (!_context) {
        const window = getWindow();
        const document = getDocument();
        if (
            window &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            (window as any).__PRELOADED_CONTEXT__
        ) {
            _context = getServerData().context;
        } else if (document) {
            _context = getJSONScriptData(
                "thelabui-react-context",
            ) as ReactivatedContext | null;
        }
    }
    return _context;
};
